import { ContentApiProvider } from '@content-api/provider';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@shared/hooks';
import { useEffect, FC } from 'react';
import React from 'react';

import { Language } from '../i18n';

export const ContentProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  const { i18n } = useTranslation();
  const language = i18n.language as Language;

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['content-api'] });
  }, [language, queryClient, token]);

  const mobilityHubPrivateBaseUrl = import.meta.env.VITE_MOBILITY_HUB_PRIVATE_URL;
  const infoCenterPublicBaseUrl = import.meta.env.VITE_INFO_CENTER_PUBLIC_URL;
  const infoCenterPrivateBaseUrl = import.meta.env.VITE_INFO_CENTER_PRIVATE_URL;
  const locale = language ?? 'pl';

  return (
    <ContentApiProvider
      mobilityHubPrivateBaseUrl={mobilityHubPrivateBaseUrl}
      infoCenterPrivateBaseUrl={infoCenterPrivateBaseUrl}
      infoCenterPublicBaseUrl={infoCenterPublicBaseUrl}
      locale={locale}
      token={token}
    >
      {children}
    </ContentApiProvider>
  );
};
